import { employeePositions } from './employeePositions';
import {
  TYPE_STUDIO,
  TYPE_PREP,
  TYPE_SET,
  TYPE_COPY,
  TYPE_TRANSLATION_FRENCH,
  TYPE_TRANSLATION_JAPANESE,
  TYPE_TRANSLATION_CHINESE,
  TYPE_RETOUCH,
  TYPE_ACC_PREP,
  TYPE_COPY_PREP,
  TYPE_INVENTORY_PREP,
  TYPE_POIRIER_SET,
  TYPE_ASSISTANT_TEAM,
} from './booking';

// A map of position ID to the group that the position belongs in, for the purposes of determining which callsheet should be sent.
const positionGroups = {
  visualProduction: [
    employeePositions.WOMENSWEAR_MODEL,
    employeePositions.MENSWEAR_MODEL,
    employeePositions.BOYSWEAR_MODEL,
    employeePositions.GIRLSWEAR_MODEL,
    employeePositions.BOYSWEAR_FIT_MODEL,
    employeePositions.GIRLSWEAR_FIT_MODEL,
    employeePositions.WOMENSWEAR_FIT_MODEL,
    employeePositions.MENSWEAR_FIT_MODEL,
    employeePositions.HMU_ARTIST,
    employeePositions.HAIR_SPECIALIST,
    employeePositions.BEAUTY_SPECIALIST,
    employeePositions.RTW_PHOTOGRAPHER,
    employeePositions.WOMENSWEAR_STYLIST,
    employeePositions.MENSWEAR_STYLIST,
    employeePositions.RTW_SET_ASSISTANT,
    employeePositions.RTW_SET_COORDINATOR,
    employeePositions.ACC_PHOTOGRAPHER,
    employeePositions.ACC_SET_COORDINATOR,
    employeePositions.ACC_STYLIST,
    employeePositions.RETOUCHER,
    employeePositions.WOMENSWEAR_MFL_ASSISTANT,
    employeePositions.MENSWEAR_MFL_ASSISTANT,
    employeePositions.STYLING_ASSISTANT,
    employeePositions.ACC_ASSISTANT,
    employeePositions.INVENTORY_ASSISTANT,
    employeePositions.STUDIO_ASSISTANT,
  ],
  contentLocalization: [
    employeePositions.COPYWRITER,
    employeePositions.COPY_ASSISTANT,
    employeePositions.ENGLISH_EDITOR,
    employeePositions.FRENCH_EDITOR,
    employeePositions.FRENCH_TRANSLATOR,
    employeePositions.JAPANESE_EDITOR,
    employeePositions.JAPANESE_TRANSLATOR,
    employeePositions.CHINESE_EDITOR,
    employeePositions.CHINESE_TRANSLATOR,
    employeePositions.INVENTORY_ASSISTANT
  ],
  everythingElse: [
    employeePositions.EE_PHOTOGRAPHER,
    employeePositions.EE_STYLIST,
    employeePositions.EE_SET_COORDINATOR,
    employeePositions.STILL_LIFE_SET_ASSISTANT,
    employeePositions.POIRIER_ASSISTANT
  ],
  management: [
    employeePositions.MENSWEAR_ASSISTANT,
    employeePositions.WOMENSWEAR_ASSISTANT,
    employeePositions.WOMENSWEAR_MERCHANDISE_COORDINATOR,
    employeePositions.MENSWEAR_MERCHANDISE_COORDINATOR,
    employeePositions.ACC_MERCHANDISE_COORDINATOR,
    employeePositions.COPY_MERCHANDISE_COORDINATOR,
    employeePositions.STYLING_ROOM_COORDINATOR,
    employeePositions.ASSOCIATE_PRODUCER,
    employeePositions.MENSWEAR_ASSOCIATE_PRODUCER,
    employeePositions.WOMENSWEAR_ASSOCIATE_PRODUCER,
    employeePositions.ACC_ASSOCIATE_PRODUCER,
    employeePositions.ASSISTANT_PRODUCER,
    employeePositions.RETOUCH_PRODUCER,
    employeePositions.CONTENT_AND_LOCALIZATION_ASSOCIATE_PRODUCER,
    employeePositions.STUDIO_ASSISTANT_COORDINATOR
  ],
};

// locationType to Producer (position name) map
// If the location type is gender-dependent, we return two position names in order of male, female.
const producerMapping = {
  [TYPE_STUDIO]: [employeePositions.MENSWEAR_ASSOCIATE_PRODUCER, employeePositions.WOMENSWEAR_ASSOCIATE_PRODUCER],
  [TYPE_PREP]: [employeePositions.MENSWEAR_ASSOCIATE_PRODUCER, employeePositions.WOMENSWEAR_ASSOCIATE_PRODUCER],
  [TYPE_SET]: employeePositions.ACC_ASSOCIATE_PRODUCER,
  [TYPE_ACC_PREP]: employeePositions.ACC_ASSOCIATE_PRODUCER,
  [TYPE_COPY]: employeePositions.CONTENT_AND_LOCALIZATION_ASSOCIATE_PRODUCER,
  [TYPE_TRANSLATION_FRENCH]: employeePositions.CONTENT_AND_LOCALIZATION_ASSOCIATE_PRODUCER,
  [TYPE_TRANSLATION_JAPANESE]: employeePositions.CONTENT_AND_LOCALIZATION_ASSOCIATE_PRODUCER,
  [TYPE_TRANSLATION_CHINESE]: employeePositions.CONTENT_AND_LOCALIZATION_ASSOCIATE_PRODUCER,
  [TYPE_RETOUCH]: employeePositions.RETOUCH_PRODUCER,
  [TYPE_COPY_PREP]: employeePositions.CONTENT_AND_LOCALIZATION_ASSOCIATE_PRODUCER,
  [TYPE_INVENTORY_PREP]: employeePositions.STUDIO_ASSISTANT_COORDINATOR,
  [TYPE_POIRIER_SET]: employeePositions.EE_SET_COORDINATOR,
  [TYPE_ASSISTANT_TEAM]: employeePositions.STUDIO_ASSISTANT_COORDINATOR
};

const onSitelocations = {
  POIRIER: 'POIRIER',
  CHABANEL: 'CHABANEL'
};

const CallSheetEmailStatus = {
  FAILED: -1,
  NOT_SENT: 0,
  SENT: 1,
  IN_PROGRESS: 2,
}

const shouldSendCallSheetStatus = [CallSheetEmailStatus.FAILED, CallSheetEmailStatus.NOT_SENT, false];

export {
  positionGroups,
  producerMapping,
  onSitelocations,
  shouldSendCallSheetStatus,
  CallSheetEmailStatus,
};
